import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
export function Leaderboard({ title, description, rows, limit = 5, empty, valueLabel, className, }) {
    const [expanded, setExpanded] = React.useState(false);
    const isEmpty = rows.length === 0;
    const max = React.useMemo(() => rows.reduce((m, r) => (r.value > m ? r.value : m), 0), [rows]);
    const visible = expanded ? rows : rows.slice(0, limit);
    const hidden = Math.max(0, rows.length - limit);
    return (<Card className={cn('border-border/60 overflow-hidden', className)}>
            <CardHeader className="gap-1 pb-3">
                <div className="flex items-baseline justify-between gap-3">
                    <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
                    {valueLabel ? (<span className="text-xs uppercase tracking-wide text-muted-foreground/70">{valueLabel}</span>) : null}
                </div>
                {description ? <CardDescription className="text-xs">{description}</CardDescription> : null}
            </CardHeader>
            <CardContent className="pt-0">
                {isEmpty ? (<div className="flex h-32 items-center justify-center rounded-md bg-muted/20 text-sm text-muted-foreground">
                        {empty ?? 'No data yet'}
                    </div>) : (<ul className="space-y-2.5">
                        {visible.map((row, i) => {
                const share = row.share !== undefined ? row.share : max > 0 ? row.value / max : 0;
                const pct = Math.round(share * 100);
                const Wrapper = row.onClick ? 'button' : 'div';
                return (<li key={row.key}>
                                    <Wrapper type={row.onClick ? 'button' : undefined} onClick={row.onClick} className={cn('group block w-full rounded-md text-left', row.onClick && 'cursor-pointer hover:bg-muted/40 px-2 -mx-2 py-1.5')}>
                                        <div className="flex items-center justify-between gap-3">
                                            <div className="flex min-w-0 items-center gap-2.5">
                                                <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-muted text-[10px] font-semibold text-muted-foreground tabular-nums">
                                                    {i + 1}
                                                </span>
                                                <div className="min-w-0">
                                                    <p className="truncate text-sm font-medium text-foreground">
                                                        {row.label}
                                                    </p>
                                                    {row.secondary ? (<p className="truncate text-xs text-muted-foreground">
                                                            {row.secondary}
                                                        </p>) : null}
                                                </div>
                                            </div>
                                            <div className="flex items-baseline gap-2 text-right">
                                                <span className="text-sm font-semibold tabular-nums text-foreground">
                                                    {row.value.toLocaleString()}
                                                </span>
                                                <span className="text-xs tabular-nums text-muted-foreground w-9">
                                                    {pct}%
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-muted/60">
                                            <div className={cn('h-full rounded-full bg-foreground/40 transition-[width]', row.barClassName)} style={{ width: `${Math.max(2, pct)}%` }}/>
                                        </div>
                                    </Wrapper>
                                </li>);
            })}
                    </ul>)}

                {!isEmpty && hidden > 0 ? (<button type="button" onClick={() => setExpanded((v) => !v)} className="mt-3 text-xs font-medium text-muted-foreground hover:text-foreground">
                        {expanded ? 'Show less' : `+${hidden} more`}
                    </button>) : null}
            </CardContent>
        </Card>);
}
